import {createRootContextHook} from 'common/util/react';

export const useDragAndDropManager = createRootContextHook(`dragAndDropManager`);
